<template>
  <div class="mb-10">
    <HeaderBar :title="hTitle" />
    <div class="my-4">
      If your payment is delayed and/or insufficient, your account will
      automatically incur penalties.
      <!-- The following below are the penalties
      imposed on late or non-payment of monthly amortizations -->
    </div>
    <div class="border-b-2 border-gray-400 py-8">
      <div class="border-b-2 border-gray-500 font-bold">
        How to avoid incurring penalties:
      </div>
      <ul class="my-2">
        <li class="flex">
          <img
            class="mr-4 h-[16px] w-[16px]"
            src="../../../../../assets/icons/check.png"
            alt=""
          />
          Pay the correct amount required on or before the scheduled due date.
        </li>
        <li class="flex">
          <img
            class="mr-4 h-[16px] w-[16px]"
            src="../../../../../assets/icons/check.png"
            alt=""
          />
          Settle payments in advance if your due date will land on a holiday or
          weekend.
        </li>
        <li class="flex">
          <img
            class="mr-4 h-[16px] w-[16px]"
            src="../../../../../assets/icons/check.png"
            alt=""
          />Set monthly reminders for your upcoming scheduled payments.
        </li>
      </ul>
    </div>
    <div class="my-4 py-8 border-b-2 border-gray-400">
      <div class="border-b-2 border-gray-500 font-bold">
        How to stop penalties from incurring:
      </div>

      <div>
        You will need to update your account. This means you will need to settle
        the unpaid balances and penalties incurred. You may acquire the correct
        amount to settle by requesting for your Statement of Account on the Home
        Page.
      </div>
    </div>
    <div class="my-4 py-8 border-b-2 border-gray-400">
      <div class="border-b-2 border-gray-500 font-bold">Things to remember:</div>
      <ul class="my-2">
        <li class="flex">
          <img
            class="mr-4 h-[16px] w-[16px]"
            src="../../../../../assets/icons/check.png"
            alt=""
          />There is no grace period for the down payment stage
        </li>
        <li class="flex">
          <img
            class="mr-4 h-[16px] w-[16px]"
            src="../../../../../assets/icons/check.png"
            alt=""
          />
          <div>
            If your due date lands on a weekend or on a holiday, settle your
            payment before that weekend or holiday to avoid late posting of the
            bank or late remittance of the payment facility.
          </div>
        </li>
        <li class="flex">
          <img
            class="mr-4 h-[16px] w-[16px]"
            src="../../../../../assets/icons/check.png"
            alt=""
          />
          If you are settling payments from overseas, give at least 3-5 working
          days allowance before your scheduled due date to settle payments to
          avoid late remittance of the payment facility and late posting to your
          account.
        </li>
      </ul>
    </div>
    <!-- <div class="text-center flex justify-center sm:px-[200px] bg-[#ccc]">
      <div class="flex justify-center border-gray-300 rounded-lg">
        <table class="table-fixed w-full bg-white m-10">
          <tr>
            <td class="p-2 border border-gray-300">No. of Days Past Due</td>
            <td class="p-2 border border-gray-300">Penalty</td>
          </tr>
          <tr>
            <td class="p-2 border border-gray-300">1-30</td>
            <td class="p-2 border border-gray-300">5%</td>
          </tr>
          <tr>
            <td class="p-2 border border-gray-300">31-60</td>
            <td class="p-2 border border-gray-300">10%</td>
          </tr>
          <tr>
            <td class="p-2 border border-gray-300">61-90</td>
            <td class="p-2 border border-gray-300">15%</td>
          </tr>
          <tr>
            <td class="p-2 border border-gray-300">91-120</td>
            <td class="p-2 border border-gray-300">20%</td>
          </tr>
          <tr>
            <td class="p-2 border border-gray-300">121-150</td>
            <td class="p-2 border border-gray-300">25%</td>
          </tr>
          <tr>
            <td class="p-2 border border-gray-300">151-180</td>
            <td class="p-2 border border-gray-300">30%</td>
          </tr>
          <tr>
            <td class="p-2 border border-gray-300">181-210</td>
            <td class="p-2 border border-gray-300">35%</td>
          </tr>
          <tr>
            <td class="p-2 border border-gray-300">211-240</td>
            <td class="p-2 border border-gray-300">40%</td>
          </tr>
          <tr>
            <td class="p-2 border border-gray-300">241-270</td>
            <td class="p-2 border border-gray-300">45%</td>
          </tr>
          <tr>
            <td class="p-2 border border-gray-300">271-300</td>
            <td class="p-2 border border-gray-300">50%</td>
          </tr>
          <tr>
            <td class="p-2 border border-gray-300">301-330</td>
            <td class="p-2 border border-gray-300">55%</td>
          </tr>
          <tr>
            <td class="p-2 border border-gray-300">331-365</td>
            <td class="p-2 border border-gray-300">60%</td>
          </tr>
          <tr>
            <td class="p-2 border border-gray-300">365 and Over</td>
            <td class="p-2 border border-gray-300">
              60% + penalty rate of the number in excess of 365 days
            </td>
          </tr>
        </table>
      </div>
    </div> -->
  </div>
</template>

<script>
import HeaderBar from "../../components/HeaderBar.vue";
export default {
  components: { HeaderBar },
  props: ["hTitle"],
};
</script>